import { frameworkBaseGame } from "../../../core/components/basegame/configuration/basegameconfiguration"
import { basegameAssetConfig } from "../../../data/basegame/index";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


frameworkBaseGame.data = {

    "POS_X": 0,
    "POS_Y": 0,
    "COMPONENTS": [
        {
            "id": "GameBaseGameContainer_baseLayer",
            "name": "GameBaseGameContainer_baseLayer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "baseLayer",
            child: [
                {
                    "id": "GameBaseGameComponent",
                    "name": "GameBaseGame",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [
                        {
                            "name": "image_basegame-bg",
                            "image": "baseGameBgImage",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1920,
                            "height": 1080,
                            "x": 0,
                            "y": 0
                        },

                        // {
                        //     "name": "bg_top_vines",
                        //     "image": "bg_top_vines",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "width": 1234,
                        //     "height": 73,
                        //     "x": 344,
                        //     "y": 47
                        // },
                        //   {
                        //       "name": "basegame_megaways_banner",
                        //       "image": "basegame_megaways_banner",
                        //       "type": "Image",
                        //       "class": "",
                        //       "layout": false,
                        //       "uimode": "desktop",
                        //       "visible": true,
                        //       "width": 560,
                        //       "height": 103,
                        //       "x": 675,
                        //       "y": 25
                        //   },
                        // {
                        //     "id": "bgSpine_gamelogo",
                        //     "name": "game_logo",
                        //     "type": "Spine",
                        //     "x": 140,
                        //     "y": 270,
                        //     "width": 53,
                        //     "height": 37,
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "anchor": [0, 0],
                        //     "spinedata": {
                        //         "spinename": "game_logo",
                        //         "animationname": "animation",
                        //         "loop": true,
                        //         "timeScale": 0.9
                        //
                        //     },
                        //
                        //     
                        // },
                        {
                            "id": "basegameLeave_desktop",
                            "name": "basegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 552,
                            "width": 1916,
                            "height": 1012,
                            "layout": false,
                            "uimode": "desktop",

                            //  "scale"
                            "visible": true,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "basegameLeave",
                                "animationname": ["basegame"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "id": "basegameLeave_mobile",
                            "name": "basegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 552,
                            "width": 1916,
                            "height": 1012,
                            "layout": true,
                            "uimode": "mobile",

                            //  "scale"
                            "visible": true,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "basegameLeave",
                                "animationname": ["basegame"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },



                        {
                            "id": "basegameLeave_desktop",
                            "name": "basegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 553,
                            "width": 1916,
                            "height": 1012,
                            "layout": false,
                            "uimode": "desktop",

                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "basegameLeave",
                                "animationname": ["rope"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "id": "basegameLeave_mobile",
                            "name": "basegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 553,
                            "width": 1916,
                            "height": 1012,
                            "layout": true,
                            "uimode": "mobile",

                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "basegameLeave",
                                "animationname": ["rope"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "name": "bg_bottom_grass",
                            "image": "bg_bottom_grass",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1920,
                            "height": 289,
                            "x": 2,
                            "y": 773
                        },



                        {
                            "name": "bg_bottom_grass",
                            "image": "bg_bottom_grass",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1920,
                            "height": 289,
                            "x": 2,
                            "y": 773
                        },
                        {
                            "name": "BG_frame_Image_Desktop",
                            "image": "Bg_frame",
                            "type": "Image",
                            "layout": false,
                            "uimode": "desktop",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 1409,
                            "height": 963,
                            "x": 957.5,
                            "y": 527.5
                        },

                        {
                            "name": "BG_frame_Image_mobile",
                            "image": "Bg_frame",
                            "type": "Image",
                            "layout": true,
                            "uimode": "mobile",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 1409,
                            "height": 963,
                            "x": 957.5,
                            "y": 527.5
                        },

                    ]
                }
            ]
        },
        {
            "id": "GameBaseGameContainer_specialLayer",
            "name": "GameBaseGameContainer_specialLayer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "specialAnimationLayer",
            child: [
                {
                    "id": "GameBaseGameComponent",
                    "name": "GameBaseGame",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [








                        {
                            "name": "bg_front_grass",
                            "image": "bg_front_grass",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1243,
                            "height": 179,
                            "x": 329,
                            "y": 862
                        },


                        {
                            "name": "bg_front_grass_mobile",
                            "image": "bg_front_grass",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1243,
                            "height": 179,
                            "x": 329,
                            "y": 862
                        },
                        {
                            "name": "header_meter",
                            "image": "header_meter",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 926,
                            "height": 128,
                            "x": 484,
                            "y": 6
                        },



                        {
                            "name": "header_meter_mobile",
                            "image": "header_meter",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 926,
                            "height": 128,
                            "x": 484,
                            "y": 6
                        },
                        // {
                        //     "name": "total_win_meter_bg",
                        //     "image": "total_win_meter_bg",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "width": 314,
                        //     "height": 667,
                        //     "x": 29,
                        //     "y": 327
                        // },



                        // {
                        //     "id": "Base_game_vines",
                        //     "name": "Base_game_vines",
                        //     "type": "Spine",
                        //     "x": 960,
                        //     "y": 595,
                        //     "width": 1919,
                        //     "height": 1049,
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "anchor": [0, 0],
                        //     "spinedata": {
                        //         "spinename": "Base_game_vines",
                        //         "animationname": "basegame",
                        //         "loop": true,
                        //         "timeScale": 0.9

                        //     },
                        // },
                        // {
                        //     "id": "Base_game_vines_butterfly",
                        //     "name": "Base_game_vines_butterfly",
                        //     "type": "Spine",
                        //     "x": 960,
                        //     "y": 595,
                        //     "width": 1919,
                        //     "height": 1049,
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "anchor": [0, 0],
                        //     "spinedata": {
                        //         "spinename": "Base_game_vines",
                        //         "animationname": "butterfly",
                        //         "loop": true,
                        //         "timeScale": 0.9

                        //     },
                        // },


                        {
                            "id": "bodyBuilderCharecterIdle_desktop",
                            "name": "bodyBuilderCharacterIdle_desktop",
                            "type": "Spine",
                            "x": 1638,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "bodyBuilderCharacterAction_desktop",
                            "name": "bodyBuilderCharacterAction_desktop",
                            "type": "Spine",
                            "x": 1638,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },




                        {
                            "id": "bodyBuilderCharecterIdle_mobile",
                            "name": "bodyBuilderCharacterIdle_mobile",
                            "type": "Spine",
                            "x": 1538,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "bodyBuilderCharacterAction_mobile",
                            "name": "bodyBuilderCharacterAction_mobile",
                            "type": "Spine",
                            "x": 1538,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },





                        {
                            "id": "skeletonCharacterIdle_desktop",
                            "name": "skeletonCharacterIdle_desktop",
                            "type": "Spine",
                            "x": 1684,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "skeletonCharectarAction_desktop",
                            "name": "skeletonCharacterAction_desktop",
                            "type": "Spine",
                            "x": 1684,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },



                        {
                            "id": "skeletonCharacterIdle_mobile",
                            "name": "skeletonCharacterIdle_mobile",
                            "type": "Spine",
                            "x": 1584,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "skeletonCharectarAction_mobile",
                            "name": "skeletonCharacterAction_mobile",
                            "type": "Spine",
                            "x": 1584,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },















                        {
                            "id": "animChangeEffect_desktop",
                            "name": "animChangeEffect_desktop",
                            "type": "Spine",
                            "x": 1640,
                            "y": 976,
                            "width": 1039,
                            "height": 1012,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "animChangeEffect",
                                "animationname": "trans",
                                "loop": false,
                                "timeScale": 0.9
                            },
                            "parentLayer": "specialAnimationLayer",
                        },




                        {
                            "id": "animChangeEffectContainer_mobile",
                            "name": "animChangeEffectContainer_mobile",
                            "type": "Container",
                            "class": "",
                            "x": 1540,
                            "y": 976,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": false,
                            // "scale": 0.4,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "animChangeEffect_mobile",
                                    "name": "animChangeEffect_mobile",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 1039,
                                    "height": 1012,
                                    "layout": true,
                                    "uimode": "mobile",
                                    "visible": false,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "animChangeEffect",
                                        "animationname": "trans",
                                        "loop": false,
                                        "timeScale": 0.9
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                            ]
                        },




                        {
                            "id": "game_logoContainer_desktop",
                            "name": "game_logoContainer_desktop",
                            "type": "Container",
                            "class": "",
                            "x": 202,
                            "y": 157,
                            "scale": 0.5,
                            "layout": false,
                            "uimode": "desktop",
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "game_logo_desktop",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,
                                    //  "scale"
                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["idol"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "game_logo_desktop",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,

                                    //  "scale"
                                    "visible": false,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["action"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },

                        {
                            "id": "game_logoContainer_mobile",
                            "name": "game_logoContainer_mobile",
                            "type": "Container",
                            "class": "",
                            "x": 202,
                            "y": 157,
                            "scale": 0.5,
                            "layout": true,
                            "uimode": "mobile",
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "game_logo",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,
                                    //  "scale"
                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["idol"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "game_logo",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,

                                    //  "scale"
                                    "visible": false,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["action"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },

                        //   {
                        //       "name": "mobileViewBottomBArImage1",
                        //       "image": "mobileViewBottomBarImage1",
                        //       "type": "Image",
                        //       "class": "",
                        //       "layout": true,
                        //       "parentLayer": "specialAnimationLayer",
                        //       "uimode": "mobile",
                        //       "filterTypes": [],
                        //       "visible": true,
                        //       "width": 1920,
                        //       "height": 150,
                        //       "x": 0,
                        //       "y": 872
                        //   },
                        //   {
                        //       "name": "mobileViewBottomBArImage2",
                        //       "image": "mobileViewBottomBarImage2",
                        //       "type": "Image",
                        //       "class": "",
                        //       "layout": true,
                        //       "parentLayer": "specialAnimationLayer",
                        //       "uimode": "mobile",
                        //       "filterTypes": [],
                        //       "visible": true,
                        //       "width": 1920,
                        //       "height": 70,
                        //       "x": 0,
                        //       "y": 1010
                        //   },


                        //  {
                        //      "id": "bodyBuilderCharacterBtn_desktop",
                        //      "name": "bodyBuilderCharacterBtn_desktop",
                        //      "type": objectTypes.Sprite,
                        //      "interactive": true,
                        //      "width": 85,
                        //      "height": 118,
                        //      "x": 1402,
                        //      "y": 874,
                        //      "text": "",
                        //      "anchor": [0.5, 0.5],
                        //      "visible": true,
                        //      "buttonMode": true,
                        //      "buttonState": {
                        //          up: 'bodybuilder_btn.png',
                        //          out: 'bodybuilder_btn.png',
                        //          down: 'bodybuilder_btn.png',
                        //          disable: 'bodybuilder_btn.png',
                        //          enable: 'bodybuilder_btn.png',
                        //          hover: 'bodybuilder_btn.png'
                        //      },
                        //      "hitareaVisible": false,
                        //      "shapeVisible": false,
                        //      "shape": {}
                        //  },
                        {
                            "id": "btnGlowContainerdesktop",
                            "name": "btnGlowContainerdesktop",
                            "type": "Container",
                            "class": "",
                            "x": 1447,
                            "y": 905,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": false,
                            "scale": 0.4,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "btnGlow_desktop",
                                    "name": "btnGlow_desktop",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 228,
                                    "height": 228,

                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "btnGlow",
                                        "animationname": "fx_glow_yellow",
                                        "loop": false,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },



                        {
                            "id": "btnGlowContainermobile",
                            "name": "btnGlowContainermobile",
                            "type": "Container",
                            "class": "",
                            "x": 1447,
                            "y": 905,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": false,
                            "scale": 0.4,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "btnGlow_desktop",
                                    "name": "btnGlow_desktop",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 228,
                                    "height": 228,

                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "btnGlow",
                                        "animationname": "fx_glow_yellow",
                                        "loop": false,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },

                        //ddddddddddddddddddddddddddd
                        {
                            "name": "bodyBuilderCharacterBtn_desktop",
                            "image": "bodyBuilderCharacterBtn",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "desktop",
                            "filterTypes": [],
                            "visible": false,
                            "width": 100,
                            "height": 118,
                            "x": 1388,
                            "y": 874
                        },
                        {
                            "name": "skeletonCharacterBtn_desktop",
                            "image": "skeletonCharacterBtn",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "desktop",
                            "filterTypes": [],
                            "visible": true,
                            "width": 100,
                            "height": 118,
                            "x": 1388,
                            "y": 874
                        },
                        {
                            "name": "skeletonCharacterBtn_mobile",
                            "image": "skeletonCharacterBtnMob",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "mobile",
                            "filterTypes": [],
                            "visible": true,
                            "width": 184,
                            "height": 191,
                            "x": 1349,
                            "y": 814
                        },
                        {
                            "name": "bodyBuilderCharacterBtn_mobile",
                            "image": "bodyBuilderCharacterBtnMob",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "mobile",
                            "filterTypes": [],
                            "visible": false,
                            "width": 184,
                            "height": 191,
                            "x": 1349,
                            "y": 814
                        },

                        {
                            "id": "text_M9",
                            "name": "startText",
                            "type": "Text",
                            "layout": false,
                            "uimode": "desktop",
                            "x": 1407,
                            "y": 969,
                            "width": 60,
                            "text": "characterSwitch",
                            "visible": true,
                            "scaleToFit": true,
                            "anchor": [0, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 20,
                                fontStyle: 'bold',
                                fill: ['#000000'],

                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "id": "text_M9",
                            "name": "startText_mob",
                            "type": "Text",
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1407,
                            "y": 969,
                            "width": 90,
                            "text": "characterSwitch_Mobile",
                            "visible": true,
                            "scaleToFit": true,
                            "anchor": [0, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 20,
                                fontStyle: 'bold',
                                fill: ['#000000'],

                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        //  {
                        //      "id": "BG_BitMapText_1_desktop",
                        //      "name": "BG_multiwaysText_desktop",
                        //      "type": "BitMapText",
                        //      "x": 820,
                        //      "y": 65,
                        //      "width": 740,
                        //      "text": "0",
                        //      "visible": true,
                        //      "scaleToFit": true,
                        //      "layout": true,
                        //      "uimode": "desktop",
                        //      "textStyle": {
                        //          font: '55px num-export',
                        //          letterSpacing: -5

                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },


                        //  {
                        //      "id": "GameHorizontalGridContainerTag",
                        //      "name": "HorizontalGridContainer",
                        //      "type": "Tag",
                        //      "class": "",
                        //      "parentLayer": "specialAnimationLayer",
                        //      "filterTypes": [],
                        //      "x": 0,
                        //      "y": 0,
                        //      child: []
                        //  },
                        {
                            "id": "SkullContainer",
                            "name": "SkullContainer",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },

                        {
                            "id": "winShowerContainerTag",
                            "name": "WinShower",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },

                        /* {
                            "id": "BG_win_Text_Bg_Image",
                            "name": "BG_win_Text_Bg_Image",
                            "type": objectTypes.Sprite,
                            "buttonMode": false,
                            "uimode": "desktop",
                            "interactive": false,
                            "x": 1221,
                            "y": 929,
                            "width": 262,
                            "height": 68,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'win.png',
                                out: 'win.png',
                                down: 'win.png',
                                disable: 'win.png',
                                enable: 'win.png',
                                hover: 'win.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        }, */

                        /* {
                            "id": "text_6",
                            "name": "text_win_value1",
                            "uimode": "desktop",
                            "type": "Text",
                            "x": 1350,
                            "y": 964.5,
                            "width": 200,
                            "visible": false,
                            "text": "abc",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 36,
                                fontWeight: 'bold',
                                fill: ['#ffffff'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        }, */
                        /* {
                             "id": "text_M2",
                             "name": "Mobiletext_mobColonSymbol1",
                             "layout": true,
                             "uimode": "mobile",
                             "type": "Text",
                             "x": 876,
                             "y": 932,
                             "width": 28,
                             "text": "buttonPanelText_13",
                             "scaleToFit": true,
                             "anchor": [0.5, 0.5],
                             "textStyle": {
                                 fontFamily: 'Arial',
                                 fontSize: 60,
                                 fontWeight: 'bold',
                                 fill: ['#666666'],
                             },
                             "parentLayer": "specialAnimationLayer",
                         },
 
                         {
                             "id": "text_M3",
                             "name": "Mobiletext_win_value",
                             "type": "Text",
                             "layout": true,
                             "uimode": "mobile",
                             "x": 1068,
                             "y": 936,
                             "width": 406,
                             "visible": false,
                             "text": "abc",
                             "scaleToFit": true,
                             "anchor": [0, 0.5],
                             "textStyle": {
                                 fontFamily: 'Arial',
                                 fontSize: 60,
                                 fill: ['#ffffff'],
                             },
                             "parentLayer": "specialAnimationLayer",
                         },
                         {
                             "id": "text_M5",
                             "name": "Mobiletext_mobColonSymbol2",
                             "layout": true,
                             "uimode": "mobile",
                             "type": "Text",
                             "x": 274,
                             "y": 1048,
                             "width": 18,
                             "text": "buttonPanelText_13",
                             "scaleToFit": true,
                             "anchor": [0.5, 0.5],
                             "textStyle": {
                                 fontFamily: 'Arial',
                                 fontSize: 36,
                                 fontWeight: 'bold',
                                 fill: ['#666666'],
                             },
                             "parentLayer": "specialAnimationLayer",
                         },
 
 
 
 
                         {
                             "id": "text_M8",
                             "name": "Mobiletext_mobColonSymbol3",
                             "layout": true,
                             "uimode": "mobile",
                             "type": "Text",
                             "x": 1650,
                             "y": 1048,
                             "width": 18,
                             "text": "buttonPanelText_13",
                             "scaleToFit": true,
                             "anchor": [0.5, 0.5],
                             "textStyle": {
                                 fontFamily: 'Arial',
                                 fontSize: 36,
                                 fontWeight: 'bold',
                                 fill: ['#666666'],
                             },
                             "parentLayer": "specialAnimationLayer",
                         },
                         {
                             "id": "text_M6",
                             "name": "Mobiletext_balance_value",
                             "type": "Text",
                             "layout": true,
                             "uimode": "mobile",
                             "x": 300,
                             "y": 961,
                             "width": 206,
                             "text": "MobViewButtonPanelText2",
                             "scaleToFit": true,
                             "anchor": [0, 0.5],
                             "textStyle": {
                                 fontFamily: 'Arial',
                                 fontSize: 36,
                                 fill: ['#ffffff'],
                             },
                             "parentLayer": "specialAnimationLayer",
                         },
 
                         {
                             "id": "text_M9",
                             "name": "Mobiletext_bet_value",
                             "type": "Text",
                             "layout": true,
                             "uimode": "mobile",
                             "x": 1674,
                             "y": 1050,
                             "width": 140,
                             "text": "MobViewButtonPanelText3",
                             "scaleToFit": true,
                             "anchor": [0, 0.5],
                             "textStyle": {
                                 fontFamily: 'Arial',
                                 fontSize: 36,
                                 fill: ['#ffffff'],
 
                             },
                             "parentLayer": "specialAnimationLayer",
                         },*/





                        {
                            "name": "win_panel",
                            "image": "total_win_meter_bg",
                            "type": "Image",
                            "layout": false,
                            "uimode": "desktop",
                            //"anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 314,
                            "height": 667,
                            "x": 29,
                            "y": 327
                        },

                        {
                            "name": "win_panel_mobile",
                            "image": "total_win_meter_bg",
                            "type": "Image",
                            "layout": true,
                            "uimode": "mobile",
                            //"anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 314,
                            "height": 667,
                            "x": 29,
                            "y": 327
                        },
                        {
                            "name": "bottomBarForPortrait",
                            "type": "Graphic",
                            "shape": "rectangle",
                            "visible": true,
                            "layout": true,
                            "uimode": "mobile",
                            "alpha": 0.94,
                            "color": "0x000000",
                            "x": 0,
                            "y": 1750,
                            "width": 1080,
                            "height": 160,

                        },


                        {
                            "id": "total_win_text",
                            "name": "total_win_text",
                            "type": "Text",
                            "layout": false,
                            "uimode": "desktop",
                            "width": 200,
                            "height": 667,
                            "x": 92,
                            "y": 493,
                            "text": "mainScreen_TotalWin",
                            "scaleToFit": true,
                            "visible": true,

                            "anchor": [0, 0.5],
                            "textStyle": {
                                fontFamily: 'Impact',
                                fontSize: 46,
                                fontStyle: 'bold',
                                fill: ['#f0e700', '#fd9d08'],
                                wordWrap: true,
                                wordWrapWidth: 600,
                                stroke: '#ca0606',
                                strokeThickness: 4,
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "id": "total_win_text_mobile",
                            "name": "total_win_text_mobile",
                            "type": "Text",
                            "layout": true,
                            "uimode": "mobile",
                            "width": 314,
                            "height": 667,
                            "x": 92,
                            "y": 493,
                            "text": "TOTAL WIN",
                            "scaleToFit": true,
                            "visible": true,

                            "anchor": [0, 0.5],
                            "textStyle": {
                                fontFamily: 'Impact',
                                fontSize: 46,
                                fontStyle: 'bold',
                                fill: ['#f0e700', '#fd9d08'],
                                wordWrap: true,
                                wordWrapWidth: 200,
                                stroke: '#ca0606',
                                strokeThickness: 4,
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        /*     {
                                "name": "total_win_text",
                                "image": "total_win_text",
                                "type": "Image",
                                "class": "",
                                "layout": false,
                                "uimode": "desktop",
                                "visible": true,
                                "width": 221,
                                "height": 54,
                                "x": 76,
                                "y": 468
                            }, */


                        /*   {
                              "name": "total_win_text_mobile",
                              "image": "total_win_text",
                              "type": "Image",
                              "class": "",
                              "layout": true,
                              "uimode": "mobile",
                              "visible": true,
                              "width": 221,
                              "height": 54,
                              "x": 76,
                              "y": 468
                          }, */
                        /* {
                            "id": "BG_balance_Text_Bg_Image",
                            "name": "BG_balance_Text_Bg_Image",
                            "type": objectTypes.Sprite,
                            "buttonMode": false,
                            "uimode": "desktop",
                            "interactive": false,
                            "x": 1499,
                            "y": 929,
                            "width": 262,
                            "height": 68,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'balance.png',
                                out: 'balance.png',
                                down: 'balance.png',
                                disable: 'balance.png',
                                enable: 'balance.png',
                                hover: 'balance.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        }, */


                        /*  {
                             "id": "truncateHitAreaContainerTag",
                             "name": "TruncateHitArea",
                             "type": "Tag",
                             "class": "",
                             "parentLayer": "specialAnimationLayer",
                             "filterTypes": [],
                             child: []
                         }, */

                        {
                            "id": "GiantWild",
                            "name": "GiantWild",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "RandomWild",
                            "name": "RandomWild",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "StreakEffectContainer",
                            "name": "StreakEffectContainer",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },

                        {
                            "id": "WinPanelComponent",
                            "name": "winPanel",
                            "type": "Tag",
                            "class": "",
                            "filterTypes": [],
                            child: [

                            ]
                        },
                        {
                            "id": "GameRulesContainer",
                            "name": "GameRulesContainer",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "GameSettingsContainer",
                            "name": "GameSettingsContainer",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "BetHistoryComponent",
                            "name": "BetHistoryComponent",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        // {
                        //     "id": "RainbowWildComponent",
                        //     "name": "RainbowWildComponent",
                        //     "type": "Tag",
                        //     "class": "",
                        //     "parentLayer": "specialAnimationLayer",
                        //     "filterTypes": [],
                        //     child: []
                        // },

                        //{
                        //    "id": "multiplierContainerTag",
                        //    "name": "Multiplier",
                        //    "type": "Tag",
                        //    "class": "",
                        //    "parentLayer": "specialAnimationLayer",
                        //    "filterTypes": [],
                        //    child: []
                        //},


                        // {
                        //     "id": "MainSettingPanelComponent",
                        //     "name": "MainSettingPanelComponent",
                        //     "type": "Tag",
                        //     "class": "",
                        //     "parentLayer": "specialAnimationLayer",
                        //     "filterTypes": [],
                        //     child: []
                        // },

                        // {
                        //     "id": "MainSettingPanelPortraitComponent",
                        //     "name": "MainSettingPanelPortraitComponent",
                        //     "type": "Tag",
                        //     "class": "",
                        //     "parentLayer": "specialAnimationLayer",
                        //     "filterTypes": [],
                        //     child: []
                        // },

                        {
                            "id": "CanvasAutoplayForMobile",
                            "name": "CanvasAutoplayForMobile",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },

                        {
                            "name": "ui_base",
                            "image": "ui_base.png",
                            "type": objectTypes.Sprite,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1920,
                            "height": 84,
                            "x": 0,
                            "y": 996,
                        },
                        {
                            "name": "ui_base_mobile",
                            "image": "ui_base.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1920,
                            "height": 84,
                            "x": 0,
                            "y": 996,
                        },
                        {
                            "id": "BuyFeature",
                            "name": "BuyFeature",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },

                        {
                            "id": "BaseGameReconstruction",
                            "name": "BaseGameReconstruction",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                    ]
                }
            ]
        },


    ]
}